import { useEffect, useState } from "react";
import { getContacts } from "../../../api/apiServices";

export default function ContactDashboard() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const res = await getContacts();
      setMessages(res.data);
    } catch (error) {
      console.error("Failed to fetch contacts", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>Loading contact messages...</p>;

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">Contact Messages</h2>

      <div className="overflow-x-auto">
        <table className="w-full border">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">Name</th>
              <th className="p-2 border">Email</th>
              <th className="p-2 border">Subject</th>
              <th className="p-2 border">Message</th>
              <th className="p-2 border">Date</th>
            </tr>
          </thead>
          <tbody>
            {messages.map((item) => (
              <tr key={item._id}>
                <td className="p-2 border">{item.name}</td>
                <td className="p-2 border">{item.email}</td>
                <td className="p-2 border">{item.subject}</td>
                <td className="p-2 border max-w-sm truncate">
                  {item.message}
                </td>
                <td className="p-2 border">
                  {new Date(item.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
